import { fecthGet, fecthPost } from '@/hotelcem/apis/request'

export default {
  // 字段数据字典
  fetchCommentDictDetail(params) {
    return fecthPost('/cem/dataCube/dict/list', params)
  },
  // 点评渠道详情
  fetchCommentChannelDetail(params) {
    let url = params?.deptId ? '/cem/comment/examine-channel/detail-by-deptid' : '/cem/comment/examine-channel/detail'
    return fecthGet(url, params)
  },
  // 点评渠道编辑
  fetchCommentChannelEdit(params) {
    return fecthPost('/cem/comment/examine-channel/edit', params)
  },
  // 点评回复渠道详情
  fetchCommentReplyChannelDetail(params) {
    let url = params?.deptId
      ? '/cem/comment/examine-reply-channel/detail-by-deptid'
      : '/cem/comment/examine-reply-channel/detail'
    return fecthGet(url, params)
  },
  // 点评回复渠道编辑
  fetchCommentReplyChannelEdit(params) {
    return fecthPost('/cem/comment/examine-reply-channel/edit', params)
  },
  // 华客分设置详情
  fetchVocustScoreDetail(params) {
    let url = params?.deptId
      ? '/cem/vocust-score-task/tenant-config/detail-by-deptid'
      : '/cem/vocust-score-task/tenant-config/detail'
    return fecthGet(url, params)
  },
  // 华客分设置编辑
  fetchVocustScoreEdit(params) {
    return fecthPost('/cem/vocust-score-task/tenant-config/edit', params)
  },
  fetchEdit(params) {
    return fecthPost('/cem/comment/calculate-rule/edit', params)
  },
  fetchDetail(params) {
    let url = params?.deptId ? '/cem/comment/calculate-rule/detail-by-deptid' : '/cem/comment/calculate-rule/detail'
    return fecthGet(url, params)
  },
  // KPI-Config
  listKPIConfig(params) {
    return fecthPost('/kpi-config/list', params)
  },
  addKPIConfig(params) {
    return fecthPost('/kpi-config/add', params)
  },
  editKPIConfig(params) {
    return fecthPost('/kpi-config/edit', params)
  },
  deleteKPIConfig(kpiConfigUid) {
    return fecthPost(`/kpi-config/delete?kpiConfigUid=${kpiConfigUid}`)
  },
  enableKPIConfig(kpiConfigUid) {
    return fecthPost(`/kpi-config/enable?kpiConfigUid=${kpiConfigUid}`)
  },
  disableKPIConfig(kpiConfigUid) {
    return fecthPost(`/kpi-config/disable?kpiConfigUid=${kpiConfigUid}`)
  },
  /**点评详情 */
  fetchCommentDetail(params) {
    return fecthPost('', params)
  },
}
